const VERD_RIDER_CREATED_THROUGH = {
  ORDER_DETAILS_POPUP: 'order_details_popup',
  VERD_TAB: 'verd_tab',
};
export default VERD_RIDER_CREATED_THROUGH;
